import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProspectingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Prospecting",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14.663 6.93c-.488-.183-1.034-.012-1.333.413s-.274 1 .061 1.397c.246.292 2.124 2.647.772 4.973l-.807-.807a1.14 1.14 0 0 0-1.616 0c-1.437 1.437-2.05 2.874-2.05 4.808A6.293 6.293 0 0 0 15.976 24c3.584 0 6.286-2.948 6.286-6.857 0-4.542-2.912-8.455-7.599-10.213m1.313 14.785c-2.243 0-4-1.758-4-4.001 0-.927.185-1.63.642-2.314l.835.836a1.14 1.14 0 0 0 1.617.001c1.788-1.789 2.075-3.786 1.737-5.505 2.006 1.622 3.17 3.899 3.17 6.41 0 2.65-1.683 4.573-4 4.573"
    }), /*#__PURE__*/_jsx("path", {
      d: "m31.665 30.05-5.203-5.204A13.65 13.65 0 0 0 29.714 16c0-7.562-6.152-13.714-13.714-13.714S2.286 8.438 2.286 16 8.438 29.714 16 29.714c3.37 0 6.456-1.228 8.847-3.252l5.202 5.203a1.14 1.14 0 0 0 1.616.001 1.143 1.143 0 0 0 0-1.616M4.572 16C4.572 9.698 9.698 4.571 16 4.571S27.428 9.698 27.428 16 22.302 27.429 16 27.429 4.572 22.302 4.572 16"
    })]
  }));
};
ProspectingIcon.displayName = 'ProspectingIcon';